import { c as _c } from "react/compiler-runtime";
import React, { createContext, FunctionComponent, PropsWithChildren, useMemo, useState } from 'react';
import { FixedContentPortal } from '../../fixedContent/FixedContentPortal/FixedContentPortal';
import { useResizeObservedElement } from '../../hooks/useResizeObservedElement';
import { prepareProps } from '../../utils/propUtils';
import styles from './FixedButtonContainerProvider.module.css';
export const FixedButtonContainerProviderContext = createContext<FixedButtonContainerProviderValue>({
  containerElement: null
});
export type FixedButtonContainerProviderValue = {
  containerElement: HTMLElement | null;
};
export type FixedButtonContainerProviderProps = PropsWithChildren<Record<never, never>>;
export const FixedButtonContainerProvider: FunctionComponent<FixedButtonContainerProviderProps> = React.memo(props => {
  const $ = _c(19);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    children
  } = t0;
  const [containerElement, setContainerElement] = useState(null);
  const [containerElementHeight, setContainerElementHeight] = useState(0);
  let t1;
  if ($[2] !== containerElement) {
    t1 = {
      containerElement
    };
    $[2] = containerElement;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const contextValue = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      box: "border-box"
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== containerElement) {
    t3 = () => {
      setContainerElementHeight(containerElement?.getBoundingClientRect().height ?? 0);
    };
    $[5] = containerElement;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== containerElement || $[8] !== t3) {
    t4 = {
      element: containerElement,
      observeOptions: t2,
      callback: t3
    };
    $[7] = containerElement;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  useResizeObservedElement(t4);
  const t5 = contextValue.containerElement ? children : null;
  let t6;
  if ($[10] !== contextValue || $[11] !== t5) {
    t6 = <FixedButtonContainerProviderContext.Provider value={contextValue}>{t5}</FixedButtonContainerProviderContext.Provider>;
    $[10] = contextValue;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = `${containerElementHeight}px`;
  let t8;
  if ($[13] !== t7) {
    t8 = <div style={{
      height: t7
    }} data-testid="FixedButtonContainerProvider.Placeholder" />;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <FixedContentPortal><div ref={setContainerElement} className={styles.buttonWrapper} /></FixedContentPortal>;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t6 || $[17] !== t8) {
    t10 = <>{t6}{t8}{t9}</>;
    $[16] = t6;
    $[17] = t8;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
});